import { React } from "react";
import { useLanguage } from "context/TextProvider";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Zoom } from "@material-ui/core";
import classNames from "classnames";
import LogoSection from "./Sections/LogoSection/LogoSection";

const useStyles = makeStyles(styles);

export default function PageNotFoundScreen() {
  const dictionary = useLanguage();
  const classes = useStyles();
  return (
    <Zoom in>
      <div
        className={classNames(classes.main, classes.mainRaised)}
        style={{ background: "white" }}
      >
        <center>
          <LogoSection />
          <Typography variant="h4" className={classes.description}>
            {dictionary.pageNotFoundScreen.text1}
          </Typography>
          <br />
          <Typography variant="body1" className={classes.description}>
            {dictionary.pageNotFoundScreen.text2}
          </Typography>
          <br />
          <br />
          <br />
          <br />
        </center>
      </div>
    </Zoom>
  );
}
